export const DEFAULT_QR_CODE_WIDTH = 300;
export const DEFAULT_QR_CODE_HEIGHT = 300;
